/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetMerchantTotalLocalCashAvailableRequest} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'
import {GetMerchantTotalLocalCashAvailableResponse} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'


export const getMerchantTotalLocalCashAvailable = (request: GetMerchantTotalLocalCashAvailableRequest, options?: CashRequestOptions) => post<GetMerchantTotalLocalCashAvailableRequest, GetMerchantTotalLocalCashAvailableResponse>("/2.0/cash/get-merchant-total-local-cash-available", request, {...options, rejectOnError: true })